import { queryOptions, useQuery } from "@tanstack/react-query";
import axios from "axios";

import { getConsistentColorForString } from "@av/components/utilities/color-utilities";
import { DEMO_1_FEMALE_EMAIL, DEMO_2_MALE_EMAIL } from "../../demo-experience/demo-users";
import { AUTH_API_URL } from "../common";

export type User = {
  id: string;
  email: string;
  displayName: string;
  company: {
    id: string;
    commonName: string;
    logoUrl: string;
  };
};

export type UserUI = User & {
  avatarUri?: string;
  avatarColor: string;
  initials: string;
  fullDisplayName?: string;
};

export const currentUserQueryOptions = queryOptions({
  queryKey: ["current-user"],
  staleTime: Infinity,
  queryFn: async () => {
    const { data: user } = await axios.get<User>(`${AUTH_API_URL}/current-user`);
    const avatarColor = getConsistentColorForString(user.displayName);
    const initials = user.displayName
      .split(" ")
      .slice(0, 4)
      .map((e) => e.charAt(0).toUpperCase())
      .join("");
    let avatarUri;

    if (user.email === DEMO_2_MALE_EMAIL) {
      avatarUri = "/sample-avatars/avatar_male_1.jpg";
    } else if (user.email === DEMO_1_FEMALE_EMAIL) {
      avatarUri = "/nancy_avatar.png";
    }

    const userUI: UserUI = {
      ...user,
      avatarColor,
      initials,
      fullDisplayName: user.displayName,
      displayName: user.displayName.split(" ")[0],
      avatarUri,
    };

    return userUI;
  },
});

export const useCurrentUser = () => useQuery(currentUserQueryOptions);
